import React, { useCallback, useMemo } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import classNames from 'classnames';
import isUrl from 'is-url';
import { TextareaAutosize } from '@material-ui/core';
import { useTranslation } from "../../../../hooks/useTranslation";
import { makeStyles, Button, useAlert } from "../../../../index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        position: 'relative',
        height: '100%',
        overflow: 'hidden',
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.light.background.default,
    },
    containerBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    sideBox: {
        flex: 1,
        minWidth: 180,
    },
    mainBox: {
        flex: 2,
        height: '100%',
        alignItems: 'center',
    },
    textarea: {
        fontSize: theme.typography.body1.fontSize,
        width: '100%',
        maxWidth: 800,
        maxHeight: 400,
        minHeight: 200,
    },
    sideButton: {
        width: 160,
        margin: theme.spacing(1, 1),
    },
}); });
export var QrCodeResult = function (props) {
    var result = props.result;
    var t = useTranslation().t;
    var alert = useAlert().alert;
    var handleOnCopy = useCallback(function () { return alert(t('テキストをコピーしました。')); }, [alert, t]);
    var isResultUrl = useMemo(function () { return isUrl(result); }, [result]);
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classNames(classes.sideBox, classes.containerBox) }),
        React.createElement("div", { className: classNames(classes.mainBox, classes.containerBox) },
            React.createElement(TextareaAutosize, { className: classes.textarea, value: result, readOnly: true })),
        React.createElement("div", { className: classNames(classes.sideBox, classes.containerBox) },
            React.createElement(CopyToClipboard, { text: result, onCopy: handleOnCopy },
                React.createElement(Button, { className: classes.sideButton, variant: "square" }, t('コピー'))),
            isResultUrl && (React.createElement(Button, { className: classes.sideButton, variant: "square", href: result, isTargetBlank: true }, t('リンクを開く'))))));
};
